import { createContext, useContext, useEffect, useState } from 'react';
import { AUTH_EVENTS } from './AuthContext';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchUserProfile = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      console.log('[USER] No hay token en localStorage');
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      console.log('[USER] Obteniendo perfil de usuario del backend...');
      
      const response = await fetch('/db/api/user/profile', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        cache: 'no-store',
      });

      if (!response.ok) throw new Error('No se pudo obtener el perfil');

      const userData = await response.json();
      console.log('[USER] Datos recibidos del backend:', userData);
      
      const userId = userData._id || userData.id;
      if (!userId) {
        console.error('[USER] Error: Usuario sin ID en la respuesta del backend:', userData);
        throw new Error('Error en la respuesta del servidor: Usuario sin ID');
      }
      
      const finalUser = {
        ...userData,
        _id: userId,
        id: userId
      };
      
      console.log('[USER] Perfil obtenido del backend:', { id: userId, user: finalUser });
      
      localStorage.setItem('user', JSON.stringify(finalUser));
      
      const loginData = {
        token,
        user: finalUser
      };
      sessionStorage.setItem('loginData', JSON.stringify(loginData));
      
      setUser(finalUser);
      
      const updateEvent = new CustomEvent('user:updated', { 
        detail: { user: finalUser }
      });
      window.dispatchEvent(updateEvent);
      
    } catch (error) {
      console.error('[USER] Error al obtener el perfil:', error);
      setUser(null);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handleLogin = () => {
      console.log('Login detectado en UserContext, obteniendo perfil real');
      fetchUserProfile();
    };
    
    window.addEventListener(AUTH_EVENTS.LOGIN, handleLogin);
    
    return () => {
      window.removeEventListener(AUTH_EVENTS.LOGIN, handleLogin);
    };
  }, []);
  
  useEffect(() => {
    fetchUserProfile();
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser, isLoading, fetchUserProfile }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);